<template>
  <gv-modal :modal="modal" :size="isMobile ? 'sm' : 'md'">
    <template #header>
      <div class="flex flex-row items-center justify-between rounded-t-lg bg-grey-25 p-3">
        <div class="size-6" />
        <gv-type uplifted-variant="subtitle-sm">{{ t('Xl8AE9UY8GOXB1IjXIgbE') }}</gv-type>
        <gv-button class="flex" variant="text" scheme="custom" size="custom" type="button" @click="modal.setClosed">
          <gv-icon name="close" :aria-label="t('BcEIKFwEZZ7082KqKVCFw')" />
        </gv-button>
      </div>
    </template>

    <template #default>
      <div class="flex flex-col items-center gap-4 p-6 text-center">
        <div class="flex flex-col !items-center gap-2">
          <gv-type uplifted-variant="body-1" align="center"
            ><b>{{ t('tRBixGJc0ns14zTMo7shB') }}</b></gv-type
          >
          <ui-emergency-banner />
          <div v-if="geocodedPosition || position" class="flex flex-col items-center gap-2">
            <gv-type uplifted-variant="body-1" class="text-center">{{ t('ofmmVMXgenYDKWQ8HqoZh') }}</gv-type>
            <gv-type v-if="geocodedPosition" uplifted-variant="body-1" class="w-full whitespace-pre !text-center font-semibold">
              {{ formatAddress(geocodedPosition, '\n') }}
            </gv-type>

            <gv-type v-if="position" uplifted-variant="body-1" class="!text-center text-sm !text-grey-500">
              {{ t('ijhQmI2yNVnlNv3LmEO-7', [position?.coords.latitude, position?.coords.longitude]) }}
            </gv-type>
          </div>
          <div v-else>
            <gv-type uplifted-variant="body-1" class="!text-center">{{ t('OIqoy_ggpBflhaUKAyfa5') }}</gv-type>
            <gv-button variant="text" :disabled="loadingLocation" @click="getCurrentPosition()">
              <ui-spinner v-if="loadingLocation" size="xs" />
              <gv-type v-else uplifted-variant="heading" class="!text-emo-deep-blue underline">{{ t('pye2_b3U2_Rh38ZdEdpWX') }}</gv-type>
            </gv-button>
          </div>
        </div>
        <a href="tel:911">
          <button class="flex h-12 w-[280px] flex-row items-center justify-center gap-1 rounded-md bg-red text-white 2xs:w-[360px]">
            <div>{{ t('yv7oWcNAql4JSWwxja4Qt') }}</div>
          </button>
        </a>
      </div>
    </template>
  </gv-modal>
</template>

<script lang="ts" setup>
import { UseModal } from '@/common/composables/useModal';
import { BREAKPOINTS } from '@/constants';
import { formatAddress, GeocodingResponseFeatures, useGeocodeStore } from '@/features';
import { useBreakpoints } from '@vueuse/core';
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const geocode = useGeocodeStore();

defineProps<{
  modal: UseModal;
}>();

const position = ref<GeolocationPosition>();
const loadingLocation = ref(false);
const geocodedPosition = ref<GeocodingResponseFeatures>();

watch(
  () => geocode.geocodedPosition,
  () => {
    geocodedPosition.value = geocode.geocodedPosition?.features.at(0);
    loadingLocation.value = false;
  }
);

const foundPosition = (pos: GeolocationPosition) => {
  position.value = pos;
  geocode.getReverseGeocoding(position.value.coords.latitude, position.value.coords.longitude);
};

const getCurrentPosition = () => {
  loadingLocation.value = true;
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(foundPosition, () => {}, { enableHighAccuracy: true });
  }
};

const breakpoints = useBreakpoints(BREAKPOINTS);
const isMobile = breakpoints.smaller('2xs');
</script>
